// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components-DayPage-__TideSummary-module___container"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DayPage/TideSummary.module.css
// module id = 777
// module chunks = 0